import { Pressable, TextStyle, ViewStyle } from "react-native"

import IonIcons from "@expo/vector-icons/Ionicons"
import { observer } from "mobx-react-lite"

import { useAppTheme } from "src/hooks/useAppTheme"
import { ThemedStyle } from "src/theme"

export interface SendButtonProps {
  onPress: () => void
  canSend: boolean
}
export const SendButton = observer((props: SendButtonProps) => {
  const { themed, theme } = useAppTheme()

  return (
    <Pressable
      onPress={props.onPress}
      disabled={!props.canSend}
      style={({ pressed }) => ({ opacity: pressed ? 0.7 : 1 })}
    >
      <IonIcons
        name="send"
        size={20}
        color={props.canSend ? theme.colors.text : theme.colors.border}
        style={themed($sendIcon)}
      />
    </Pressable>
  )
})

const $sendIcon: ThemedStyle<TextStyle> = ({ spacing }) => ({
  padding: spacing.md,
  paddingRight: spacing.xs,
})
